/**
 * medical conditions
 */
export enum MEDICAL_CONDITION {
	CANCER = 7,
	CANCER_TEXT = 8,
	OTHER = 9,
	OTHER_REASON = 10,
}

/**
 * men health
 */
export enum MEN_HEALTH {
	OTHER = 4,
}

/**
 * women health
 */
export enum WOMEN_HEALTH {
	OTHER = 7,
}

export enum GENDER {
	MALE = 'MALE',
	FEMALE = 'FEMALE',
	UNKNOWN = 'UNKNOWN',
}
